export default __webpack_public_path__ + "static/media/zapatos-deportivos-mujer.a9b38b63.png";